export interface ResponsiveTransformConfig {
  scale: number;
  hoverAmplitude: number;
  paddingRight: number;      // pixels from right edge (0 = centered horizontally)
  verticalOffset: number;    // px offset from curtain boundary (+ = up, - = down)
}

/** @deprecated Use ResponsiveTransformConfig directly */
export type DesktopTransformConfig = ResponsiveTransformConfig;

export interface TellerAssistantConfig {
  transform: {
    position: { x: number; y: number; z: number }; // computed from responsive settings
    rotationY: number;
    scale: number;
    hoverAmplitude: number;
    // Responsive positioning
    desktop: ResponsiveTransformConfig;
    mobile: ResponsiveTransformConfig;
  };
  mesh: {
    gooScale: number;
    gooAmount: number;
    gooSpeed: number;
    gooPoleAmount: number;
    waveScale: number;
    waveFrequency: number;
    waveAmount: number;
    waveSpeed: number;
    wavePoleAmount: number;
    color: string;
    rotationSpeed: number;
    showNormals: boolean;
  };
  shell: {
    particlesCount: number;
    particlesColor: string;
    particlesSize: number;
    particlesRadius: number;
    particlesNoiseScale: number;
    particlesNoiseSpeed: number;
    particlesNoiseAmount: number;
  };
  lighting: {
    lightingType: 'simple' | 'env';
    simple: {
      lightX: number;
      lightY: number;
      lightZ: number;
      ambientLightColor: string;
      directionalLightColor: string;
      ambientLightIntensity: number;
      directionalLightIntensity: number;
    };
    env: {
      environmentLightingIntensity: number;
      environmentRotationY: number; // radians, rotates the HDR panorama around Y axis
    };
  };
}

export const defaultTellerAssistantConfig: TellerAssistantConfig = {
  transform: {
    position: { x: 0, y: 0, z: -0.02 }, // Will be computed from responsive settings
    rotationY: -0.08,
    scale: 0.0019,
    hoverAmplitude: 0.0007,
    // Responsive positioning settings
    desktop: {
      scale: 0.0019,
      hoverAmplitude: 0.0007,
      paddingRight: 140, // pixels from right edge
      verticalOffset: 0, // px offset from curtain boundary (+ = up, - = down)
    },
    mobile: {
      scale: 0.00067,
      hoverAmplitude: 0.0006,
      paddingRight: 0, // 0 = centered horizontally
      verticalOffset: 0, // px offset from curtain boundary (+ = up, - = down)
    },
  },
  mesh: {
    gooScale: 10,
    gooAmount: 0.14129404669595932,
    gooSpeed: 0.11269061773067976,
    gooPoleAmount: 1.0,
    waveScale: 0.7994055311449987,
    waveFrequency: 1.633497027655725,
    waveAmount: 1.8419919014387869,
    waveSpeed: 0.476608942879297,
    wavePoleAmount: 0.18,
    color: '#d9c7a7',
    rotationSpeed: 0.002,
    showNormals: false,
  },
  shell: {
    particlesCount: 28000,
    particlesColor: '#fff3c9',
    particlesSize: 0.01,
    particlesRadius: 1.0751270784871199,
    particlesNoiseScale: 2,
    particlesNoiseSpeed: 0.21400878780046523,
    particlesNoiseAmount: 0.25157232704402516,
  },
  lighting: {
    lightingType: 'env',
    simple: {
      lightX: 0.2,
      lightY: 0.4,
      lightZ: 0.5,
      ambientLightColor: '#ffe59c',
      directionalLightColor: '#ffeebf',
      ambientLightIntensity: 0.17,
      directionalLightIntensity: 1.45,
    },
    env: {
      environmentLightingIntensity: 3.5,
      environmentRotationY: 2.8,
    },
  },
};
